import React, { useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { useFormikContext } from "formik";
import styles from "./style.module.scss";
import FileIcon from "../../../../../../../assets/svg/icons/common/FileIcon";
import TrashIcon from "../../../../../../../assets/svg/icons/common/Trash";
import LockIcon from "../../../../../../../assets/svg/icons/common/LockIcon";
import Button from "../../../../../../../components/new-button";

const ACCEPTED = ".xls,.xlsx,.csv";
const MAX_SIZE = 52428800;

function CbdAddendum({ isKurvDomain = false }) {
  const { values, errors, setFieldValue } = useFormikContext();

  const onDrop = useCallback((accepted = []) => {
    if (accepted[0]) setFieldValue("cbd_addendum_file", accepted[0]);
  }, [setFieldValue]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: ACCEPTED,
    maxSize: MAX_SIZE,
    multiple: false,
  });

  const file = values.cbd_addendum_file;
  const fileName = file?.name || file?.file;

  return (
    <div className={styles.container}>
      <h4 className={styles.sectionTitle}>CBD Addendum</h4>
      <p className={styles.description}>
        Upload your product pricing spreadsheet with columns: <b>CBD Product</b>, <b>Price</b>, and <b>Manufacturer/Distributor</b>.
      </p>

      <div
        {...getRootProps()}
        className={`${styles.dropzone} ${isDragActive ? styles.active : ""} ${isKurvDomain ? styles.kurv : ""}`}
      >
        <input {...getInputProps()} />
        <p className={styles.dropzoneText}>
          Upload files by drag and drop or <span className={styles.clickText}>click to upload</span>
        </p>
        <p className={styles.fileTypes}>{ACCEPTED}</p>
        <div className={styles.encryption}>
          <LockIcon color="#A4A3A8" />
          <span>256-bit encryption</span>
        </div>
      </div>

      {file && (
        <div className={styles.fileRow}>
          <FileIcon size={16} color="#09944d" />
          <span className={styles.fileName} title={fileName}>{fileName}</span>
          <Button
            variant="ghost"
            size="small"
            type="button"
            icon={<TrashIcon color="#A4A3A8" />}
            onClick={() => setFieldValue("cbd_addendum_file", null)}
          />
        </div>
      )}

      {errors?.cbd_addendum_file && (
        <div className={styles.error} role="alert">{errors.cbd_addendum_file}</div>
      )}
    </div>
  );
}

export default CbdAddendum;
